module.exports = __webpack_public_path__ + "56ee8bc0e198fe8e010d023d81d329e0.svg";